@import '../../../../constants/screen-width-breakpoints.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.marketplace-settings-modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    height: 600px;
    width: 750px;
  }
}

.modal-body {
  height: 100%;
  overflow: hidden;

  @media @mobile {
    height: calc(100vh - 50px);
  }

  div,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
  }
}

.import-button {
  color: @notification--mobile-success-link--text-color;
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  padding-left: 8px;
  border: none;
  background-color: @notification--mobile-success-body--background-color;
}
